import { BALLOT_PATH } from 'constants/ballot';
import { MIDTERMS_BASE_PATH } from 'constants/midterms';

/**
 * Canonical paths for the midterms hub's routes — the single source for the
 * tab nav, page canonicals, and breadcrumbs.
 */
export const MIDTERMS_TAB_PATHS = {
    senate: MIDTERMS_BASE_PATH,
    house: `${MIDTERMS_BASE_PATH}/house`,
    governor: `${MIDTERMS_BASE_PATH}/governor`,
    states: `${MIDTERMS_BASE_PATH}/states`,
    balanceOfPower: `${MIDTERMS_BASE_PATH}/balance-of-power`,
    ballot: BALLOT_PATH,
} as const;

/** Canonical market-event destinations used by the hub's forecast cards. */
export const MIDTERMS_FORECAST_MARKET_PATHS = {
    senate: '/markets/controls/senate-winner/controls-2026',
    house: '/markets/controlh/house-winner/controlh-2026',
    governor: '/markets/kxgovwins/who-will-hold-more-governorships-after-the-midterms/kxgovwins-27jan01',
    presidential: '/markets/kxpresparty/party-winning-presidency/kxpresparty-2028',
} as const;

/** Event whose party markets drive the Balance of Power presidential forecast card. */
export const PRESIDENTIAL_FORECAST_EVENT_TICKER = 'KXPRESPARTY-2028';

export { GOVERNOR_FORECAST_EVENT_TICKER } from 'constants/midterms';

/**
 * The hub route a pathname belongs to — for chrome rendered by the shared
 * layout, which can't know its page statically. The request-scoped `/v`
 * variant of each route (see src/proxy.ts) maps to its tab; unknown paths
 * read as the hub root (Senate).
 */
export function midtermsTabForPath(pathname: string): keyof typeof MIDTERMS_TAB_PATHS {
    const path = pathname.replace(/\/$/, '').replace(/\/v$/, '');
    const match = (Object.keys(MIDTERMS_TAB_PATHS) as (keyof typeof MIDTERMS_TAB_PATHS)[]).find(
        (tab) => MIDTERMS_TAB_PATHS[tab] === path,
    );
    return match ?? 'senate';
}
